var exports = {
  "x": "notificationIndicator__UfCozT",
};

module.exports = exports;
